export const AddUtmParameters = (
	url: string | string[] | undefined,
	medium: string,
	campaign: string,
	source: string = 'meta_catalog', // Default source to meta_catalog
): string => {
	if (!url) return ''
	try {
		const urlStr = Array.isArray(url) ? url[0] : url
		const urlObj = new URL(urlStr)
		urlObj.searchParams.set('utm_source', source)
		urlObj.searchParams.set('utm_medium', medium)
		urlObj.searchParams.set('utm_campaign', campaign)
		return urlObj.toString()
	} catch (error) {
		console.error('Invalid URL:', error)
		return ''
	}
}
